export const loaded = (state) => {
  if (state.campgrounds !== [] && state.campsites !== [] && state.campsiteTypes !== []) {
    return true
  } else {
    return false
  }
}
export const campgrounds = (state) => state.campgrounds
export const campsites = (state) => state.campsites
export const campsitesFiltered = (state) => {
  // if none are loaded
  if (!state.campsites) {
    return []
  }
  // filter
  return state.campsites.filter((campsite) =>
    (campsite.campgroundID === state.searchCriteria.campground || state.searchCriteria.campground === null) && // match campground or any(null)
    (campsite.campsiteTypeID === state.searchCriteria.campsiteType || state.searchCriteria.campsiteType === null) && // match campsite type or any(null)
    (state.searchCriteria.accessible === false || Number(campsite.accessible) === Number(state.searchCriteria.accessible)) && // match accessible if not selected or if selected and true
    (state.searchCriteria.campfire === false || Number(campsite.campfire) === Number(state.searchCriteria.campfire)) && // match campfire if not selected or if selected and true
    (Number(campsite.adminOnly) === Number(state.searchCriteria.admin)) &&
    (state.searchCriteria.showUnavailable || campsite.datesAvailable)
  )
}
export const campsiteTypes = (state) => state.campsiteTypes
export const parkingAreas = (state) => state.parkingAreas
export const searchCriteria = (state) => state.searchCriteria
